import type { components } from '@/schema'
import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { playerGameStatsColumns } from './constants'

type PlayerGameStatsItem = components['schemas']['PlayerGameStatsItemResponse']

interface PlayerGameStatsTableProps {
	data: PlayerGameStatsItem[]
	total: number
	isLoading?: boolean
}

export default function PlayerGameStatsTable({
	data,
	total,
	isLoading,
}: PlayerGameStatsTableProps) {
	return (
		<DataTablePaginate
			columns={playerGameStatsColumns}
			data={data}
			totalItems={total}
			isLoading={isLoading}
		/>
	)
}
